module.exports = __webpack_public_path__ + "static/media/VideoStreamFrame2.d1f81e19.png";